/**
 * @property {number} retryAfter Seconds after the user should retry
 */
export default class TooManyRequestsError extends Error {
  /**
   * @param {number} retryAfter
   */
  constructor(retryAfter) {
    super(`Too many requests. Wait for ${retryAfter} seconds and try again`)
    Object.defineProperty(this, 'retryAfter', {
      value: retryAfter,
    })
  }
}
